import { options_premium__subTitle_primaryUser } from './DomainOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import store from './store/store';
import { SubscriberType } from './contracts/subscriberType';
import { HMPlusBit } from 'owa-domain-connect';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let DomainOption: LazyOption = createLazyOption(
    {
        key: 'domain',
        titleStringKey: options_premium__subTitle_primaryUser,
        searchTermsStringKey: options_premium__subTitle_primaryUser,
        hideTitleInFullOptions: false,
        isHidden: () =>
            !isFeatureEnabled('auth-domainConnect') ||
            !isFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            !(store.subscriberType == SubscriberType.Primary) ||
            (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) ==
                HMPlusBit ||
            !(store.domainState.isDomainCreated || store.domainState.isDomainRemoved),
    },
    lazyFullModule,
    m => m.default
);
export default DomainOption;
